import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { FieldOption, StatusGroup } from 'api/tasks';
import { StatusPicker } from 'components/atoms/status-picker';
import { useProjectPhaseStatusField } from 'data/fields/hooks/account-fields';

export const PhaseStatusDropdown: FC<{
  status: number;
  onChange(status: FieldOption<StatusGroup>): void;
  disabled?: boolean;
}> = ({ status, onChange, disabled = false }) => {
  const projectPhaseStatusField = useProjectPhaseStatusField();
  const currentProjectPhaseStatus =
    projectPhaseStatusField.metaData.options.find(
      (_status) => _status.value === status,
    );

  if (!currentProjectPhaseStatus) {
    return <>{status}</>;
  }

  return (
    <StatusPicker
      dropdownHeader={<FormattedMessage id="projects.phase.status" />}
      onChange={onChange}
      field={projectPhaseStatusField}
      value={currentProjectPhaseStatus.value}
    >
      <StatusPicker.Trigger
        shape="round"
        selectedStatus={currentProjectPhaseStatus}
        progress={0}
        disabled={disabled}
      />
    </StatusPicker>
  );
};
